import type { ComboboxOption } from '@/components/ui/combobox'

export function flattenLocations(
  nodes: { title?: string; value?: string; children?: unknown[] }[],
  parent = ''
): ComboboxOption[] {
  const out: ComboboxOption[] = []
  for (const node of nodes ?? []) {
    const children = node?.children
    if (Array.isArray(children) && children.length > 0) {
      out.push(...flattenLocations(children as typeof nodes, node.title))
    } else if (node?.value) {
      out.push({
        value: String(node.value),
        label: parent ? `${node.title}, ${parent}` : (node.title ?? '')
      })
    }
  }
  return out
}
